import type { BaselineTrackTarget, BenchmarkTarget } from './types';

export const getBaselineTrackTarget = async ({
  familyId,
}: {
  familyId: string;
}): Promise<BaselineTrackTarget> => {
  try {
    const response = await fetch(
      `/api/mixone/api/v1/track/${familyId}/performance/benchmark?baseline=avg_comp`,
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch baseline track target: ${response.statusText}`,
      );
    }

    const data = await response.json();

    return {
      familyId: data.family_id,
      firstWeekStreams: data.first_week_stream_count,
      secondWeekStreams: data.second_week_stream_count,
      firstYearStreams: data.first_year_stream_count,
    };
  } catch (error) {
    console.error('Error fetching baseline track target:', error);

    throw error;
  }
};

export const getBenchmarkTargets = async ({
  familyIds,
}: {
  familyIds: number[];
}): Promise<BenchmarkTarget[]> => {
  const trackTargets: BenchmarkTarget[] = [];

  for (const id of familyIds) {
    try {
      // @TODO WMG1-489 - Call endpoint to get saved adjusted percent and combine with baseline data
      const target = await getBaselineTrackTarget({
        familyId: id.toString(),
      });

      trackTargets.push({ ...target, adjustedPercent: 0 });
    } catch (error) {
      trackTargets.push({
        familyId: id,
        firstWeekStreams: undefined,
        secondWeekStreams: undefined,
        firstYearStreams: undefined,
        adjustedPercent: 0,
      });
    }
  }

  return trackTargets;
};
